import React, { useRef, useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import AttendanceVeiwController from "../../redux/actions/AttendenceApiAction";

import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const AddReportMonth = ({ anchorRef, handleClose, selectedIds,onSuccess }) => {
  const dispatch = useDispatch();
  const { genrateAttendanceReport } = AttendanceVeiwController();

  const [selectedMonth, setSelectedMonth] = useState(dayjs());
  const popperRef = useRef(null);

  const handleGenerate = () => {
    const payload = {
      month: selectedMonth.format("YYYY-MM"),
      employee_ids: selectedIds,
    };
    dispatch(genrateAttendanceReport(payload));
    handleClose();
     if (onSuccess) {
      onSuccess(); // ✅ Notify parent after dispatch
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        popperRef.current &&
        !popperRef.current.contains(e.target) &&
        anchorRef?.current &&
        !anchorRef.current.contains(e.target)
      ) {
        handleClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [handleClose, anchorRef]);

  if (!anchorRef?.current) return null;
  const anchorRect = anchorRef.current.getBoundingClientRect();

  return (
    <div
      ref={popperRef}
      style={{
        position: "absolute",
        top: anchorRect.bottom + window.scrollY + 8,
        left: anchorRect.left + window.scrollX,
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: 6,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        zIndex: 1050,
        width: 310,
        maxHeight: 310,
        overflow: "hidden", // hide anything that overflows, but don't scroll
        position: "absolute",
      }}
    >
      {/* Calendar unscaled */}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <StaticDatePicker
          displayStaticWrapperAs="desktop"
          openTo="month"
          views={["year", "month"]}
          value={selectedMonth}
          onChange={(newValue) => {
            setSelectedMonth(newValue);
          }}
          slotProps={{
            actionBar: { actions: [] },
          }}
        />
      </LocalizationProvider>

      {/* Buttons placed absolutely inside modal bottom */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          background: "#fff",
          borderTop: "1px solid #eee",
          padding: "6px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          size="sm"
          variant="secondary"
          onClick={handleClose}
          className="me-2"
        >
          Cancel
        </Button>
        <Button size="sm" variant="primary" onClick={handleGenerate}>
          Generate
        </Button>
      </div>
    </div>
  );
};

export default AddReportMonth;
